<button [disabled]="disabled" (click)="btnClicked.emit()" [ngClass]="class" class="btn btn-primary">
  <fa-icon class="{{textColor}}" *ngIf="faIcon" [icon]="faIcon"></fa-icon>
  <div class="font-normal {{textColor}}">{{text}}</div>
</button>